<script setup lang="ts">
import type { SectionHeroAboutRecord } from '~/types/datocms'

const appStore = useAppStore()

const props = defineProps<{
  data: SectionHeroAboutRecord
  moduleIndex: number
}>()

const { level, isSemantic } = useSectionRules(props.moduleIndex, !!props.data.title)

onMounted(() => {
  appStore.setTheme('dark')
  appStore.setGradientHeader('yellow')
})
</script>

<template>
  <div class="bg-yellow pb-10 pt-20 text-black lg:pb-24 lg:pt-30">
    <div class="container">
      <Heading v-if="data.title" :level="level" :size="1" :is-semantic="isSemantic">
        <span class="font-light [&>b]:font-normal" v-html="data.title" />
      </Heading>
    </div>
  </div>
</template>
